import Navbar from "@/Shared/Navbar";
import Footer from "@/Shared/Footer";
import { Head } from "@inertiajs/react";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import CheckCircleIcon from "@/components/Event/icons/CheckCircleIcon";
import ExclamationIcon from "@/components/Event/icons/ExclamationIcon";
import FloatContact from "@/components/Home/FloatContact";

function Layout({ children, user, title = null }) {
    const mainClassName = "content-main";
    const [popUp, setPopUp] = useState(false);
    const [success, setSuccess] = useState(false);
    const [fileName, setFileName] = useState("");
    const downRef = useRef(null);
    const getStatus = async () => {
        try {
            const randomCode = localStorage.getItem("downloadTicketCode");
            const res = await axios.get(
                `/api/getStatusDownloadEventTicket?randomCode=${randomCode}`
            );
            if (res.data.data.status == "success") {
                setFileName(res.data.data.file_name);
                setPopUp(true);
                setSuccess(true);
                downRef.current.click();
                localStorage.removeItem("downloadTicketCode");
            } else if (res.data.data.status == "failed") {
                setPopUp(true);
                setSuccess(false);
                localStorage.removeItem("downloadTicketCode");
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (popUp) {
            setTimeout(() => {
                setPopUp(false);
            }, 5000);
        }
        const interval = setInterval(() => {
            if (!localStorage.getItem("downloadTicketCode")) return;
            getStatus();
        }, 3000);
        return () => clearInterval(interval);
    }, [popUp]);

    useEffect(() => {
        const event = new Event('layoutRendered');
        document.dispatchEvent(event);
    }, []);
    return (
        <div className="layout-main">
            {popUp && (
                <>
                    <div
                        className="d-flex justify-content-between align-items-center gap-4"
                        style={{
                            position: "fixed",
                            top: "20px",
                            right: "50px",
                            padding: "16px",
                            borderRadius: "5px",
                            backgroundColor: success ? "#D4EDDA" : "#F9D0D0",
                            zIndex: "99990000",
                        }}
                    >
                        <div
                            className="d-flex justify-content-center align-items-center p-1"
                            style={{
                                backgroundColor: success
                                    ? "#3DC15D"
                                    : "#E83C3C",
                                borderRadius: "50px",
                            }}
                        >
                            {success ? (
                                <CheckCircleIcon />
                            ) : (
                                <ExclamationIcon />
                            )}
                        </div>
                        <p className="mb-0 fw-bold">
                            E-Tiket {success ? "berhasil" : "gagal"} dicetak
                        </p>

                        <i
                            className="fas fa-times text-black"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setPopUp(false);
                            }}
                        ></i>
                    </div>
                    <a
                        ref={downRef}
                        href={`/e-ticket/download/${fileName}`}
                        style={{ display: "none" }}
                    >
                        dw
                    </a>
                </>
            )}
            {title ? <Head title={title} /> : ""}
            <Navbar user={user || children?.props?.user} />
            <div className="layout-main__wrapper" scroll-region="true">
                <div className="layout-main__content">
                    {typeof children == "string" ||
                    children instanceof String ? (
                        <main
                            className={mainClassName}
                            dangerouslySetInnerHTML={{ __html: children }}
                        ></main>
                    ) : (
                        <main className={mainClassName}>{children}</main>
                    )}
                    <Footer />
                </div>
            </div>
            <FloatContact/>
        </div>
    );
}

export default Layout;
